module.exports = __webpack_public_path__ + "media/images/impact-report-gender-equality-2f81f05072595bdf2e59da5ef46a3a34.png";